import type { TFunction } from "i18next";
import { z } from "zod";

export const createLoginSchema = (t: TFunction) =>
  z.object({
    email: z
      .string({ error: t("auth.email_required") })
      .trim()
      .min(1, t("auth.email_required"))
      .email(t("auth.email_invalid")),
    password: z
      .string({ error: t("auth.password_required") })
      .trim()
      .min(8, t("auth.password_min_length")),
    rememberMe: z.boolean(),
  });

export type LoginSchema = ReturnType<typeof createLoginSchema>;
export type LoginFormInput = z.input<LoginSchema>;
export type LoginFormValues = z.output<LoginSchema>;
